import React from "react";

interface Props {
  src: string;
  className?: string;
}

const Icon: React.FC<Props> = ({ src, className }) => {
  return <img src={src} className={className} />;
};

export default Icon;
